// Assuming useNavigate is imported and used within a component
import { Link } from 'react-router-dom';
import {
    RiHomeWifiFill,
    RiSettings3Fill,
    RiAddCircleFill,
    RiLogoutCircleLine,
    RiChatNewFill,
} from "@remixicon/react";



let SIDER_ICON_COLOR = '#F1F4FE';
let ICON_SIZE = 18;

export const getSiderConfig = (logout, toggleDrawer) => {
    return [
        {
            label: "Homescreen",
            icon: <Link to="/"><RiHomeWifiFill style={{color: SIDER_ICON_COLOR}} size={ICON_SIZE}/></Link>,
            key: 'home'
        },
        {
            label: "New Portfolio",
            icon: <Link to="/builders/portfolio"><RiAddCircleFill style={{color: SIDER_ICON_COLOR}} size={ICON_SIZE}/></Link>,
            key: 'home'
        },
        {
            label: "Settings",
            icon: <Link to="/settings"><RiSettings3Fill style={{color: SIDER_ICON_COLOR}} size={ICON_SIZE}/></Link>,
            key: 'settings'
        },
        {
            label: "Sign Out",
            icon: <RiLogoutCircleLine style={{color: SIDER_ICON_COLOR}} size={ICON_SIZE} onClick={logout}/>,
            key: 'signout'
        },
        {
            label: "Prompt Generator",
            icon: <RiChatNewFill color="#F1F4FE" size={18} onClick={toggleDrawer}/>,
            key: 'gptDrawer'
        },
    ];
}
